<template>
    <div class="parent" v-if="iconographyShown">
      <v-alert
        class="mx-1"
        :value="true"
        color="warning"
        dense
        border="top"
        v-if="isCurrentVerion"
        >
        There is a <a :href="getDeptictionURLCurrent()">newer version </a> of the record available.
      </v-alert>

      <ResponsiveDesignLayer :isMedia="isMedia" :hasImage="image ? true : false" @isFlipped="resize">
      <template v-slot:left-column>
        <div class="flex-grow" v-if="image && image.isLinks">
          <div class="mx-1 mt-2 caption_dotted" >
            Related Painted Representations
            </div>
            <div class="lazy-grid-wrapper">
              <lazyTileGrid :centered="true" @loadMore="getNextResults" :items="relatedDepictions" :itemsCount="resAmount" ></lazyTileGrid>
            </div>
        </div>
        <kuchaStudiesPDFVIew v-if="image && image.isLKS" :leipzigKuchastudiesEntry="image.LKS"/>
        <AnnotatedImageView
          v-if="image && !image.is3D && isImageSet && !image.isLKS && !image.isLinks"
          @annoHover="annoHover"
          @annoHoverOut="annoHoverOut"
          :image="image"
          :isImageValid="isImageValid(image.imageID)"
          ref="annoImg"
          :highlightedAnnotations="highlightedAnnotations"
          :hideTree="true"
          v-show="showAnno"
          :item="iconographyShown"
          :annos="idealTypical.annos"
          :relatedAnnotations="iconographyShown?.oe?.relatedAnnotationList"
          :isVersion="version"
          :highlightedIcos="highlightedIcos"
          @icoSelectedChanged="icoSelectedChanged"
          @hoveredItemChanged="hoveredItemChanged"
          @selectedAnnosChanged="selectedAnnosChanged"
          @setHighlightedIcos="setHighlightedIcos"
        />
        <v-tabs ref="tabs"
          class="mx-1 px-3 pt-1 my-1"
          v-if="images.length > 1"
          v-model="imageTab"
          :key="tabKey"
          centered
          light
          slider-color="yellow"
          return-object
          style="color:rgba(255, 255, 255, 0.2) !important;flex:0"
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows

        >
          <v-tab
            v-for="(item, index) in images"
            :key="index"
            @click="setImage(item)"
            style="color:gba(255, 255, 255, 0.2) !important;"
          >
          <v-tooltip v-if="item && item.isLinks" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                x-large
              >
                mdi-image-multiple-outline
              </v-icon>
            </template>
            <span>Show Related Painted Representations</span>
          </v-tooltip>

          <v-icon x-large v-else-if="item && item.is3D">
              mdi-rotate-3d
            </v-icon>

            <v-icon x-large v-else-if="item && item.isLKS">
              mdi-book-open-variant-outline
            </v-icon>

            <v-img  v-else-if="(imageValidDic[item.imageID]) ? imageValidDic[item.imageID].valid: false"
              :src="imageValidDic[item.imageID].thumbnail"
            >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            </v-img>
            <v-icon x-large v-else>mdi-lock</v-icon>
          </v-tab>
        </v-tabs>
      </template>
      <template v-slot:right-column>
        <v-card-title class="text-h-2 mx-0 px-1 pt-1 font-weight-bold" >{{iconographyShown.text + " (ID: " + iconographyShown.iconographyID + ")"}}</v-card-title>
        <div style="position: relative;">
            <v-alert
              ref="top-hint"
              v-if="showTopHint"
              type="info"
              dense
              density="compact"
              color="primary"
              icon="mdi-arrow-up"
              :class="['mb-n15', 'hint-alert', { 'fade-out': fadingOut }]"
            >
              scroll up for more info
            </v-alert>
          </div>
          <div ref="scroll-container" class="px-2 scroll-content">
            <div class="icoTreeView">
              <v-treeview
                :items="icoTree"
                rounded
                open-all
                dense
                transition
                style="max-height: none; height: auto;"
              >
                <template class="v-treeview-node__label" slot="label" slot-scope="{ item }">
                  <div v-html="getTitle(item)"></div>
                </template>
              </v-treeview>
            </div>
          <div :key="item_name" v-for="(item_value, item_name) in idealTypical.data">
            <div class="mx-1 mt-2 caption_dotted" >
              {{ item_name }}
            </div>
            <div v-if="item_name=='dating'">
              <foruminf heading="Related Chronological Discussions" :newPosts="false" @getComments="getComments()" :discussions="discussions" :chronologicalRange="getChronologicalRange"></foruminf>
            </div>
            <AnnotatedImageTree
              ref="annoTree"
              v-if="item_name === 'Annotations'"
              :annos="idealTypical.annos"
              :relatedAnnotations="iconographyShown?.oe?.relatedAnnotationList"
              :highlightedIcos="highlightedIcos"
              :preselectedIcos="preselectedIcos"
              @mouseOverNode="mouseOverNode"
              @mouseLeaveNode="mouseLeaveNode"
              @clickAnno="clickAnno"
            ></AnnotatedImageTree>
            <v-list-item two-line v-for="(value, name, index) in item_value" :key=index>
              <v-list-item-content v-if="name !== 'Copyright'">
                <v-list-item-title >{{name}}</v-list-item-title>
                <div style="white-space: pre-line;padding:0px 0px 0px 10px;">{{value}}</div>
              </v-list-item-content>
              <div v-if="(name === 'Copyright')" style="display: inline-block;white-space: normal" v-html="name + ': ' + value"></div>
            </v-list-item>
            <div v-if="item_name === 'Bibliography'" class="mx-5">
              <v-list-item>
                <v-list-item-content>
                  <div class="mb-2" v-for="annotatedBibliography in iconographyShown.oe.relatedBibliographyList" :key="annotatedBibliography.annotatedBibliographyID">
                    <a v-if="bibliographyHasLink(annotatedBibliography)" target=”_blank”   :href="getBibUrl(annotatedBibliography)" v-html="getBibTitle(annotatedBibliography)"></a>
                    <div v-else v-html="getBibTitle(annotatedBibliography)"> </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </div>

          </div>
              <div v-show="versions.length>1">
                <div class="mx-1 caption_dotted">
                  Versions
                </div >
                <v-combobox
                  class="d-flex justify-center align-center mx-8"
                  v-model="version"
                  :items="versions"
                  label="Select Version"
                  outlined
                  dense
                  item-text = "date"
                  item-value="_id"
                ></v-combobox>
              </div>
        </div>
        <div style="position: relative;">
            <v-alert
              ref="top-hint"
              v-if="showBottomHint"
              type="info"
              dense
              density="compact"
              color="primary"
              icon="mdi-arrow-down"
              :class="['mt-n15', 'hint-alert', { 'fade-out': fadingOut }]"
            >
              scroll down for more info
            </v-alert>
          </div>
      </template>
      </ResponsiveDesignLayer>

  </div>
</template>

<script>
import {fillPicsContainer, getIdsOfChildren, getLeipzigKuchastudiesEntries, bibliographyHasLink, getBibTitle} from '@/utils/helpers'
import {getDepictionByAnnotation, getVersionsOfEntry, getVersionOfEntry, getCommentsByItems} from '@/services/repository'
import Foruminf from '../components/foruminf.vue'
import { getChronologicalRange } from '../utils/helpers'
import osdImgViewer from '../components/osdImgViewer.vue'
import ResponsiveDesignLayer from './ResponsiveDesignLayer.vue'
import AnnotatedImageView from './AnnotatedImageView.vue'
import AnnotatedImageTree from './AnnotatedImageTree.vue'
import kuchaStudiesPDFVIew from './leipzigKuchaStudiesPDFView.vue'
import lazyTileGrid from './lazyTileGrid.vue'

export default {

  name: 'iconographyInf',
  props: {
    iconography: {},
  },
  components: {
    Foruminf,
    osdImgViewer,
    ResponsiveDesignLayer,
    AnnotatedImageView,
    AnnotatedImageTree,
    kuchaStudiesPDFVIew,
    lazyTileGrid,


  },
  data () {
    return {
      newDesign: true,
      tab:[],
      showDec:false,
      showImage:true,
      relatedDepictions:[],
      iconographyWithChildren:{},
      showAnno: true,
      iconographyShown:{},
      version:null,
      versions:['current'],
      showVersions: false,
      discussions: [],
      resAmount: 0,
      images: [],
      image:null,
      lastBounding: null,
      showTopHint: false,
      showBottomHint: false,
      hintTimeoutId: null,
      fadingOut: false,
      tabKey:0,
      imageTab:0,
      highlightedAnnotations: [],
      highlightedIcos: [],
      preselectedIcos: [],
      annotationIDAnnotoriousIDMap:{},
      annotoriousIDAnnotationIDMap:{},
      icoSelected: [],
      hoveredItem: null,
      pendingImageTarget: null,
    }
  },
  computed: {
    isMedia(){
      for (const image of this.images){
        if (image.is3D || image.isLKS){
          return true
        }
      }
      return false
    },
    imageValidDic (){
      return this.$store.getters.getImageValidDic ? this.$store.getters.getImageValidDic : {}
    },
    isImageSet(){
      this.$log.debug("isImageSet:", this.image);
      return Object.keys(this.image).length > 0
    },
    isCurrentVerion(){
      console.log("versions: ", this.versions, this.$route.params.version);
      if (this.$route.params.version === "current"){
        return false
      }
      return parseInt(this.$route.params.version) < this.versions.length - 1
    },
    getImages(){
      return Object.keys(this.iconography).length === 0 && this.iconography.constructor === Object ? [] : [this.iconography]
    },
    getChronologicalRange(){
      return getChronologicalRange()
    },
    hasRelatedDepictions(){
      if (this.relatedDepictions){
        if (this.relatedDepictions.length > 0){
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    hasImages(){
      this.$log.debug("hasImages:", this.iconographyShown.oe);
      if (this.iconographyShown.oe){
        if (this.iconographyShown.oe.images){
          if (this.iconographyShown.oe.images.length > 0){
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    hasAdditionalInfo(){
      this.$log.debug("idealtypical:", this.idealTypical);
      if (this.discussions.length > 0) {
        return true
      } else if (this.iconographyShown.oe){
        if (Object.keys(this.iconographyShown.oe).length > 0){
          if (Object.keys(this.idealTypical.data).length > 0){
            this.$log.debug("idealtypical returned true:", Object.keys(this.iconography.oe).length);
            return true
          } else {
            return false

          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    icoTree(){
      var returnElement = []
      for (var rootElement of this.$store.state.iconography){
        var dummy =  Object.assign({}, rootElement)
        var result = this.searchTree(dummy, this.iconographyShown)
        if (result != null){
          returnElement.push(result)
        }
      }
      this.$log.debug("returnElement icoTree", returnElement );
      return returnElement
    },

    idealTypical(){
      let icoInf = {}
      let data = {}
      let desc = {}
      console.log("iconography Entry", this.iconographyShown);
      let idealTypical = this.iconographyShown.oe
      icoInf.annos = []
      icoInf.relatedAnnotationList = []
      if (idealTypical !== undefined){
        console.log("idealTypical", idealTypical);
        let res = fillPicsContainer(idealTypical.images, idealTypical.relatedAnnotationList)
        console.log("idealTypical res", res);
        icoInf.relatedAnnotationList = idealTypical.relatedAnnotationList
        if (idealTypical.description){
          desc["Description"] = idealTypical.description
        }
        if (idealTypical.remarks){
          desc["General Remarks"] = idealTypical.remarks
        }
        icoInf['images'] = []
        if (res.images.length > 0){
          icoInf['images'] = res.images
        }
        icoInf['Iconography Tree'] = this.icoTree
        icoInf['annos'] = res.annos
      }


      if (this.image){
        if (!this.image?.is3D && !this.image?.isLKS && !this.image?.isLinks){
          console.log("image", this.image);
          data["Shown Image"] = {
            // "Title": this.image.title,
            "Filename": this.image.filename,
            "Copyright": (this.image.cc ? this.image.copyright + "<br>" + this.image.cc.html : this.image.copyright)
          }
          if (this.image.location){
            let location = this.image.location.name
            if (this.image.location.town){
              location += ", " + this.image.location.town
            }
            if (this.image.location.country){
              location += ", " + this.image.location.country
            }
            data["Shown Image"]["Location"] = location
          }
        }
      }
      if (Object.keys(desc).length > 0){
        data['Additional Information'] = desc
      }
      if (this.discussions.length > 0){
        data['dating'] = ''
      }
      icoInf['data'] = data
      if (this.iconographyShown.oe?.relatedAnnotationList?.length > 0){
        data["Annotations"] = {}
      }
      if (this.iconographyShown.oe?.relatedBibliographyList){
        if (this.iconographyShown.oe.relatedBibliographyList?.length > 0){
          data["Bibliography"] = {}
        }
      }
      console.log("icoinf", icoInf);
      return icoInf
    },

  },
  methods: {
    resolveImageFromQuery() {
      const query = this.$route.query.image

      if (!query) return null

      // Spezialtab: related
      if (query === 'related') {
        this.pendingImageTarget = 'related'
        return null
      }

      // Spezialtab: lks
      if (query === 'lks') {
        return this.images.find(img => img.isLKS)
      }

      // Spezialtab: 3d
      if (query === '3d') {
        return this.images.find(img => img.is3D)
      }

      // Normale numerische Bild-ID
      const id = parseInt(query, 10)

      if (!isNaN(id)) {
        return this.images.find(img => img.imageID === id)
      }

      return null
    },
    setHighlightedIcos(newVal){
      this.$log.debug("setHighlightedIcos in depictionInf", newVal);
      this.highlightedIcos = newVal
    },
    selectedAnnosChanged(newVal){
      this.highlightedAnnotations = newVal
      this.$router.replace({
        query: {
          ...this.$route.query,
          annotation: newVal.map(x => this.annotoriousIDAnnotationIDMap.get(x.id))
        }
      }).catch(() => {}); // optional, um den Promise-Abbruch zu ignorieren
    },
    hoveredItemChanged(newVal){
      this.$log.debug("hoveredItemChanged in depictionInf", newVal);
      this.hoveredItem = newVal
    },
    icoSelectedChanged(newVal){
      this.$log.debug("icoSelectedChanged in depictionInf", newVal);
      this.icoSelected = newVal
      this.$router.replace({
        query: {
          ...this.$route.query,
          iconography: newVal.map(x => x.id)
        }
      }).catch(() => {}); // optional, um den Promise-Abbruch zu ignorieren

    },
    getBibTitle(bib){
      return getBibTitle(bib)
    },
    getBibUrl(bib){
      if (bib.uri){
        return bib.uri
      }
      if (bib.url){
        return bib.url
      }
      return ""
    },
    bibliographyHasLink(bib){
      return bibliographyHasLink(bib)
    },
    // this image might be needed if the info area has to be updated after changing the picture.
    setImage(image) {
      if (!image) return

      this.image = image
      this.$log.debug("set image", image)

      let queryValue

      if (image.isLinks) {
        queryValue = 'related'
      } else if (image.isLKS) {
        queryValue = 'lks'
      } else if (image.is3D) {
        queryValue = '3d'
      } else {
        queryValue = String(image.imageID)
      }

      if (this.$route.query.image !== queryValue) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            image: queryValue
          }
        }).catch(() => {})
      }
    },
    getIconographyURLCurrent(){
      if (this.pr){
        if (Object.keys(this.pr).length > 0){
          return "/iconography/" + this.iconographyShown.iconographyID + "/current"
        }
      }
      return "/pr/"
    },
    mouseOverNode(item){
      this.$log.debug("mouse over!", item, this.$refs['annoImg'])
      if (this.$refs['annoImg']){
        this.$refs['annoImg'].mouseOverNode(item)
      }
    },
    selectedAnnosChanged(newVal){
      this.$router.replace({
        query: {
          ...this.$route.query,
          annotation: newVal.map(x => this.annotoriousIDAnnotationIDMap.get(x.id))
        }
      }).catch(() => {}); // optional, um den Promise-Abbruch zu ignorieren
    },
    mouseLeaveNode(item){
      this.$log.debug("mouse leave!", item)
      if (this.$refs['annoImg']) {
        this.$refs['annoImg'].mouseLeaveNode(item)
      }
    },
    clickAnno(item){
      this.$log.debug("click!", item)
      if (this.$refs['annoImg']) {
        this.$refs['annoImg'].seticoSelected(item)
      }
    },
    getIcoURL(){
      return "/iconography/" + this.iconographyShown.iconographyID
    },
    resize(){
      if (this.$refs['annoImg']){
        this.$refs['annoImg'].resize();
      }
    },
    annoHoverOut(annotation){
      this.$log.debug("annoHoverOut", annotation, this.$refs)
      this.$refs['annoTree'][0].mouseOutAnnotation(annotation)
    },
    annoHover(annotation){
      if (!annotation.id) return
      if (this.hintTimeoutId) {
        clearTimeout(this.hintTimeoutId)
        this.hintTimeoutId = null
      }
      this.$log.debug("annoHover", annotation, this.$refs)
      const treeElement = this.$refs['annoTree'][0].mouseEnterAnnotation(annotation)
      const container = this.$refs['scroll-container'];
      const topHint = this.$refs['top-hint'];
      const bottomHint = this.$refs['bottom-hint'];
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.isVisible = entry.isIntersecting;
          this.lastBounding = entry.boundingClientRect;
        },
        {
          root: container,
          threshold: 0.01, // Trigger schon bei kleinstem Teil sichtbar/nicht sichtbar
        }
      );
      observer.observe(treeElement);
      // topHint.style.display = 'none';
      // bottomHint.style.display = 'none';
      if (!this.isVisible && this.lastBounding) {
        const containerRect = container.getBoundingClientRect();

        if (this.lastBounding.top < containerRect.top) {
          // Element ist nach oben raus
          // topHint.style.display = 'block';
          this.$log.debug("topHint", topHint)
          this.showTopHint = true
        } else if (this.lastBounding.bottom > containerRect.bottom) {
          this.$log.debug("bottomHint", bottomHint)
          this.showBottomHint = true
          // Element ist nach unten raus
          // bottomHint.style.display = 'block';
        }
      }
      this.hintTimeoutId = setTimeout(() => {
        this.fadeOutHint(); // separate Funktion, siehe unten
      }, 2000)

      this.$log.debug("treeElement depiction", treeElement, this.isVisible, this.lastBounding)
    },
    getComments(){
      getCommentsByItems([], [], [this.iconographyShown.iconographyID], [])
        .then( res => {
          this.$log.debug("recieved discussions.", res.data.hits.hits)
          this.discussions = res.data.hits.hits
        }).catch(function (error) {
          this.$log.debug(error)
          return null
        })
    },

    isImageValid(imageID){
      this.$log.debug("isImageValid", imageID, this.$store.getters.getImageValidDic, this.$store.getters.getImageValidDic[imageID]?.valid)
      if (this.$store.getters.getImageValidDic){
        if (this.$store.getters.getImageValidDic[imageID]){
          return this.$store.getters.getImageValidDic[imageID].valid
        }
      }
      return false
    },
    fadeOutHint() {
      this.fadingOut = true;
      setTimeout(() => {
        this.showTopHint = false;
        this.showBottomHint = false;
        this.fadingOut = false;
      }, 1000); // Dauer des Fade-Out
    },
    getOSDURL(image){
      let tiles = []
      tiles.push(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + image.filename + "/info.json")
      return tiles
    },
    initNewIconography(){
      this.annotationIDAnnotoriousIDMap = new Map(
        this.iconographyShown.oe?.relatedAnnotationList?.map(x => [x.annotationID, x.annotoriousID])
      );
      this.annotoriousIDAnnotationIDMap = new Map(
        this.iconographyShown.oe?.relatedAnnotationList?.map(x => [x.annotoriousID, x.annotationID])
      );

      this.getRelatedDepictions()
      const _self = this
      this.images = []
      if (this.iconographyShown.oe?.images.length > 0){
        this.images = JSON.parse(JSON.stringify(this.iconographyShown.oe.images)) // this.iconographyShown.oe.images
      }
      const lksList = getLeipzigKuchastudiesEntries(this.iconographyShown.oe?.relatedBibliographyList)
      this.$log.debug("lksList", lksList, this.images)
      if (lksList.length > 0){
        this.$log.debug("has lksEntries", lksList)
        for (const lks of lksList){
          this.$log.debug("lks", lks)
          this.images.push({
            "isLKS": true,
            "LKS": lks
          })
          this.$log.debug("added lksEntry", this.images)
        }
      }
      var found = null
      this.$log.debug("this.$route.query: ", this.$route.query);
      found = this.resolveImageFromQuery()

      if (found) {
        this.$log.debug("found preselected image:", found)
        this.setImage(found)
      }
      if (this.$route.query.annotation) {
        const queryAnnotations = Array.isArray(this.$route.query.annotation)
          ? this.$route.query.annotation
          : [this.$route.query.annotation];

        // Hole die passenden annotoriousIDs:
        this.highlightedAnnotations = queryAnnotations
          .map(id => this.annotationIDAnnotoriousIDMap.get(parseInt(id)))
          .filter(id => id !== undefined);

        this.$log.debug("found preselected annotation:", queryAnnotations ,this.highlightedAnnotation, this.annotoriousIDAnnotationIDMap, this.annotationIDAnnotoriousIDMap,
          this.iconographyShown?.oe?.relatedAnnotationList.filter(item =>
            queryAnnotations.includes(item.annotationID))
        );        }
      if (this.$route.query.iconography) {
        this.$log.debug("found preselected iconography: ", this.$route.query);
        const preselectedIcosIDs = Array.isArray(this.$route.query.iconography) ? this.$route.query.iconography : [this.$route.query.iconography]
        this.$log.debug("preselectedIcosIDs: ", preselectedIcosIDs, this.icoAnnos);
        this.preselectedIcos = preselectedIcosIDs
        this.$log.debug("found preselected iconography: ", this.preselectedIcos)
      }
      if (!found) {
        this.image = this.images.find(element => element.imageID === this.iconographyShown.oe.masterImageID)
        if (!this.image) {
          this.$log.debug("masterimage not found: ", this.images);
          const image = this.images.find(element => element.is3D || element.isLKS)
          if (!image && this.images.length > 0) {
            this.image = this.images[0]
          }
          this.setImage(image)
        } else {
          this.setImage(this.image)
        }
      }
      this.imageTab = this.images.indexOf(this.image)
      this.$log.debug("masterimage found: ", this.images.find(element => element.imageID === this.iconographyShown.oe.masterImageID), this.imageTab, this.image);
      getVersionsOfEntry(this.iconographyShown)
        .then( res => {
          _self.$log.debug("recieved versions.", res.data.hits.hits)
          _self.versions = res.data.hits.hits
          if (this.versions.length){
            for (let v of _self.versions){
              v.date = new Date(v._source.timestamp)
            }
            _self.versions[_self.versions.length - 1].date = _self.versions[_self.versions.length - 1].date + " - (current)"
            _self.version = _self.versions[_self.versions.length - 1]
          }
        }).catch(function (error) {
          _self.$log.debug(error)
          return null
        })
    },
    getNextResults(from, amount){
      this.$log.debug("initiated next results", from, amount);
      this.postSearch(from, amount)
    },
    postSearch(from, size){
      let params = {}
      var allIds = getIdsOfChildren(this.iconographyWithChildren)
      params.iconographyID = allIds
      getDepictionByAnnotation(params, from, size)
        .then( res => {
          this.resAmount = res.data.hits.total.value
          this.$log.debug("relatedDepictions resAmount", this.resAmount, res);
          for ( var entry of res.data.hits.hits){
            var depiction = entry._source
            depiction["preSelected"] = this.iconography ? [this.iconography] : []
            this.relatedDepictions.push(depiction)
          }
          this.$log.debug("relatedDepictions", this.relatedDepictions);
        }).catch(function (error) {
          console.log(error)
        })
    },
    getRelatedDepictions(){
      this.relatedDepictions = []
      this.postSearch(0, 20)
    },

    setOSDimages(image){
      this.image = image
      this.$log.debug("change to ", this.getOSDURL(image), image);
      this.viewerImg.open(this.getOSDURL(image))
    },
    mouseOver: function(){
      this.showDec = !this.showDec
    },
    getItemURL(item){
      var res = ""
      res = "/iconography/" + item.iconographyID
      return res
    },
    getTitle(item){
      if (item.iconographyID === this.iconographyShown.iconographyID){
        return "<b>" + item.name + "</b>"
      } else {
        return "<a href=\"" + this.getItemURL(item) + "\" style=\"color: inherit;text-decoration: none\">" + item.name + "</a>"
      }
    },
    searchTree(element, ids){
      let copy = Object.assign({}, element)
      if (ids.iconographyID === element.iconographyID){
        element["isHeading"] = true
        this.iconographyWithChildren = element
        return element
      } else {
        if (element.children != null) {
          let newChildren = []
          for (var child of element.children) {
            var hasChildren = this.searchTree(child, ids);
            if (hasChildren != null){
              newChildren.push(hasChildren)
              copy.children = newChildren;
              copy["isHeading"] = false
              return copy
            }
          }
        }
      }
      return null
    },
    getThumbnail(image){
      return process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + image.filename + "/full/!80,80/0/default.jpg"
    },
  },
  mounted:function () {
    this.$log.debug("new Iconography started", this.iconographyShown);
    this.initNewIconography()
    if (this.iconographyShown.oe && this.iconographyShown.oe.images.length > 0){
      this.$store.dispatch('buildImageValidDic', this.iconographyShown.oe?.images)
    }
    this.getComments()
  },
  beforeMount:function () {
    this.iconographyShown = this.iconography
  },
  watch: {
    iconography:{
      handler(val){
        if (val.oe){
          if (val.oe.images?.length > 0){
            this.$log.debug("images for buildImageValidDic", val.oe.images)
            this.$store.dispatch('buildImageValidDic', val.oe.images)

          }
        }
      },
      deep: true
    },
    relatedDepictions(newVal, oldVal){
      this.$log.debug("relatedDepictions", newVal)
      var image = null
      if (newVal.length > 0){
        var foundRelatedDepictionsTab = false
        for (image of this.images){
          if (image.isLinks){
            foundRelatedDepictionsTab = true
            break
          }
        }
        if (!foundRelatedDepictionsTab){
          this.images.push({
            "isLinks": true
          })
          if (!this.image){
            this.image = this.images[this.images.length - 1]
          }
          if (this.pendingImageTarget === 'related') {
            const relatedTab = this.images.find(img => img.isLinks)

            if (relatedTab) {
              this.setImage(relatedTab)
              this.pendingImageTarget = null
            }
          }
        }
      } else {
        for (image of this.images){
          if (image.isLinks){
            this.images.splice(this.images.indexOf(image), 1)
            break
          }
        }
      }
      this.$log.debug("recieved relatedDepictions", this.images)
    },
    showAnno(newVal, oldVal){
      this.$log.debug("showAnno", this.$refs)
      this.$refs['anno'].resize()
    },
    version(newVal, oldVal){
      console.log("version changed", newVal);
      if (newVal != null){
        getVersionOfEntry(newVal._id)
          .then( res => {
            this.iconographyShown = res.data._source.content
          }).catch(function (error) {
            this.$log.debug(error)
            return null
          })
      }
    }
  },

}
</script>

<style lang="css">

.v-list-item__title{
  margin-bottom: 5px;
}
.v-tab {
  padding: 8px;
  min-width: 20px;
}

.v-tab {
  padding: 8px;
  min-width: 20px;
}

.v-treeview-node__content, .v-treeview-node__label {
  flex-shrink: 1;
  line-break: normal;
}
.v-treeview-node__root {
  height: auto;
}
.v-treeview-node {
  min-height: 10px;
}
.v-treeview--dense .v-treeview-node__root
{
  min-height: 10px;
}
.v-treeview {
overflow-x: auto;
overflow-y: auto;
max-height: 100%;
}
.sticky-header-bar {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: transparent!important;
  padding: 4px;
  border-bottom: 1px solid black;
}

.hint-alert {
  animation: blink 1s linear infinite;
  transition: opacity 1s ease;
  opacity: 1;
}

.hint-alert.fade-out {
  animation: none;
  opacity: 0;
}
.icoTreeView {
  display: block !important;
  height: auto !important;
  overflow: visible !important;
}
.lazy-grid-wrapper {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.expand-wrapper {
  overflow: hidden;
  padding: 8px;
  min-height: fit-content;
}
</style>